module.exports = {
  title: '系统公告',
  route: {
    path: '/content-manage',
    children: {
      path: 'system-notice',
    },
  },
};
